import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, desc, light = false, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    <FadeUp>
      <span className={light ? "eyebrow-light" : "eyebrow"}>{eyebrow}</span>
    </FadeUp>
    <FadeUp delay={0.08}>
      <h2
        className={`mt-4 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl ${
          light ? "text-paper" : "text-ink"
        }`}
      >
        {title}
      </h2>
    </FadeUp>
    {desc ? (
      <FadeUp delay={0.16}>
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${light ? "text-paper/70" : "text-soil"}`}>
          {desc}
        </p>
      </FadeUp>
    ) : null}
  </div>
);